import { Injectable } from '@angular/core';
import { FilterFieldConfig } from '../filter.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationsFilterBuilder {
  private fields: FilterFieldConfig[] = [];

  constructor() {}


  years(fromYear: number, yearsCount: number = 100): NotificationsFilterBuilder {
    const options = Array.from({ length: yearsCount }, (_, i) => ({
      label: (fromYear + i).toString(),
      value: fromYear + i
    }));

    this.fields.push({
      name: 'year',
      label: 'Godina',
      type: 'select',
      multiple: false,
      options,
      placeholder: 'Odaberite godinu',
      initialValue: fromYear
    });
    return this;
  }


  reset(): NotificationsFilterBuilder {
    this.fields = [];
    return this;
  }

  build(): FilterFieldConfig[] {
    return this.fields;
  }
}